export interface SeededRng {
	next(): number;
	int(maxExclusive: number): number;
}

function hashSeed(seed: string): number {
	let h = 1779033703 ^ seed.length;
	for (let i = 0; i < seed.length; i++) {
		h = Math.imul(h ^ seed.charCodeAt(i), 3432918353);
		h = (h << 13) | (h >>> 19);
	}
	return h >>> 0;
}

/** Mulberry32 PRNG — deterministic from string seed. */
export function createSeededRng(seed: string): SeededRng {
	let state = hashSeed(seed) || 1;
	return {
		next() {
			state |= 0;
			state = (state + 0x6d2b79f5) | 0;
			let t = Math.imul(state ^ (state >>> 15), 1 | state);
			t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
			return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
		},
		int(maxExclusive: number) {
			if (maxExclusive <= 0) {
				return 0;
			}
			return Math.floor(this.next() * maxExclusive);
		},
	};
}
